<div class="bgm-account-container">
  <h3>Bangumi Account</h3>
  <div class="setting-cards">
    @if (loading) {
      <div class="ui loading segment">
        <div class="ui placeholder">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
      </div>
    }
    @if (!loading && !bgmAccount) {
      <div class="ui segment">
        <p>Link your bgm.tv account to sync your watch status.</p>
        @if (!callbackLoading) {
          <button class="ui primary button" [ngClass]="{loading: linking}" [disabled]="linking" (click)="linkAccount()">
            {{linking ? 'Linking...' : 'Link Account'}}
          </button>
        }
        @if (callbackLoading) {
          <div class="ui icon info message">
            <i class="notched circle loading icon"></i>
            <div class="content">
              <div class="header">Just one second</div>
              <p>Finishing the last step for the auth. Do not refresh the browser or leaving the page!</p>
            </div>
          </div>
        }
        <app-error-message [error]="error" header="Fail to link bgm.tv account"></app-error-message>
      </div>
    }
    @if (!loading && bgmAccount) {
      <div class="ui segment linked-account">
        <div class="account-info">
          <img class="avatar" [src]="bgmAccount.avatar.medium" [alt]="bgmAccount.nickname">
          <div class="account-details">
            <div class="nickname">{{ bgmAccount.nickname }}</div>
            <div class="username">&#64;{{ bgmAccount.username }}</div>
            <a [href]="profileUrl" target="_blank" rel="noopener noreferrer">View profile on bgm.tv</a>
          </div>
        </div>
        <div class="import-progress">
          @if (syncPolling && !bgmAccount.importTotal) {
            <p>Preparing import...</p>
          }
          @if (bgmAccount.importTotal) {
            <p>Import progress: {{bgmAccount.importProgress}} / {{bgmAccount.importTotal}}</p>
          }
          @if (bgmAccount.exportTotal) {
            <p>Export progress: {{bgmAccount.exportProgress}} / {{bgmAccount.exportTotal}}</p>
          }
        </div>
        <form class="sync-options" [formGroup]="bgmAccountSettingForm">
          <div class="field">
            <ui-toggle formControlName="enableAutoSync" (change)="onAutoSyncToggled()">Auto Sync</ui-toggle>
          </div>
          @if (!syncPolling && (!bgmAccount.importTotal || bgmAccount.importTotal === bgmAccount.importProgress)) {
            <button type="button" class="ui primary button" (click)="openImportDialog()">Import</button>
          }
        </form>
        <div class="ui divider"></div>
        <button class="ui red button unlink-button" [ngClass]="{loading: unlinking}" [disabled]="unlinking" (click)="unlinkAccount()">
          {{ !unlinking ? 'Unlink Account' : 'Unlinking...' }}
        </button>
      </div>
    }
  </div>
</div>
